import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { isEqual, omit } from "lodash";

// Connects to data-controller="indicaciones-medicas-office"
export default class extends Controller {
  static targets = ["submitButton", "submitSpinner", "submitLabel"]

  static values = {
    registro: Number,
    hoja: Number,
    currentDate: String,
    currentUser: String
  }

  initialize() {
    this.indicacionesOffice = [];
    this.isSubmitting = false;
  }

  connect() {
    this.initialIndicacionesOffice = [];

    if (this.element.dataset.indicacionesOffice.length) {
      const indicacionesOffice = JSON.parse(this.element.dataset.indicacionesOffice)
      indicacionesOffice.forEach(indicacionOffice => {
        const parsedIndicacion = JSON.parse(indicacionOffice)
        const horaColoc = new Date(parsedIndicacion.HoraColoc)
        const horaColocString = horaColoc.getHours().toString() === '0' ? '00' : horaColoc.getHours().toString()

        const indicacionMedicaOffice = {
          MaterialCodigo: parsedIndicacion.MaterialCodigo,
          farmaco: parsedIndicacion.farmaco || '',
          Interno: parsedIndicacion.Interno,
          HoraColoc: horaColocString,
          Fecha: parsedIndicacion.Fecha,
          Usuario: parsedIndicacion.Usuario || this.currentUserValue,
          destroyable: false
        };

        this.indicacionesOffice.push(indicacionMedicaOffice);
        this.initialIndicacionesOffice.push({ ...indicacionMedicaOffice });
      });
    }

    this.indicacionesOffice.forEach((indicacionOffice, index) => {
      try {
        const id = `${indicacionOffice.MaterialCodigo || indicacionOffice.farmaco}-${indicacionOffice.Interno}-${indicacionOffice.HoraColoc}`;
        const el = document.getElementById(id);

        if (!el) {
          console.warn(`Checkbox NO encontrado para id=${id} (index=${index})`, indicacionOffice);
          return;
        }

        el.checked = true;
      } catch (e) {
        console.error(`Error al procesar indicacion index=${index}`, indicacionOffice, e);
      }
    });
  }

  setIndicacionOffice(e) {
    e.preventDefault();

    const indicacionMedicaDetalle = JSON.parse(e.target.dataset.indicacionMedicaDetalle);
    const horaColoc = e.target.value;
    const indicacionMedicaOffice = {
      MaterialCodigo: indicacionMedicaDetalle.MaterialCodigo,
      farmaco: this.slugify(indicacionMedicaDetalle.farmaco || '') || '',
      Interno: indicacionMedicaDetalle.Interno,
      HoraColoc: horaColoc,
      Usuario: this.currentUserValue,
      Fecha: this.currentDateValue,
      destroyable: false
    };

    const isChecked = e.target.checked;

    const indicacionOfficeIndex = this.indicacionesOffice.findIndex(ind =>
      isEqual(omit(ind, ['Usuario', 'destroyable']), omit(indicacionMedicaOffice, ['Usuario', 'destroyable']))
    );

    if (isChecked) {
      if (indicacionOfficeIndex === -1) {
        this.indicacionesOffice.push(indicacionMedicaOffice);
      } else {
        this.indicacionesOffice[indicacionOfficeIndex].destroyable = false;
      }
    } else {
      if (indicacionOfficeIndex > -1) {
        const wasInitial = this.initialIndicacionesOffice.some(ind =>
          isEqual(omit(ind, ['Usuario', 'destroyable']), omit(indicacionMedicaOffice, ['Usuario', 'destroyable']))
        );

        if (wasInitial) {
          this.indicacionesOffice[indicacionOfficeIndex].destroyable = true;
        } else {
          this.indicacionesOffice.splice(indicacionOfficeIndex, 1);
        }
      }
    }
  }

  async submit(e) {
    e.preventDefault();

    if (this.isSubmitting || e.currentTarget.classList.contains('disabled')) {
      return;
    }

    this.toggleSubmittingState(true);
    document.dispatchEvent(new CustomEvent('spinner:show'));

    try {
      await post('/indicaciones_medicas_office/batch_create', {
        responseKind: 'turbo-stream',
        body: {
          Registro: this.registroValue,
          Hoja: this.hojaValue,
          current_date: this.currentDateValue,
          indicaciones_medicas_office: this.indicacionesOffice
        }
      })
    } finally {
      this.toggleSubmittingState(false);
      document.dispatchEvent(new CustomEvent('spinner:hide'));
    }
  }

  toggleSubmittingState(submitting) {
    this.isSubmitting = submitting;

    this.submitButtonTargets.forEach((button) => {
      button.classList.toggle('disabled', submitting);
      button.setAttribute('aria-disabled', submitting ? 'true' : 'false');
      button.style.pointerEvents = submitting ? 'none' : '';
    });

    this.submitSpinnerTargets.forEach((spinner) => {
      spinner.classList.toggle('d-none', !submitting);
    });

    this.submitLabelTargets.forEach((label) => {
      label.classList.toggle('d-none', submitting);
    });

    this.element.querySelectorAll('input, select, textarea, button').forEach((control) => {
      if (control.type === 'hidden') {
        return;
      }

      if (submitting) {
        control.dataset.wasDisabled = control.disabled ? 'true' : 'false';
        control.disabled = true;
      } else if (control.dataset.wasDisabled === 'false') {
        control.disabled = false;
        delete control.dataset.wasDisabled;
      } else {
        delete control.dataset.wasDisabled;
      }
    });
  }

  slugify(text) {
    if (!text) {
      return '';
    }
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '-')
      .replace(/--+/g, '-');
  }
}
